<template>
	<div class="ma-2">
		<v-layout class="pt-2">
			<v-flex class="ml-4" xs2>
				<v-text-field
					outlined
					v-model="edited.qtdeDias"
					label="Período de dias*"
					color="#042333"
					:error-messages="erroQtdeDias"
				></v-text-field>
			</v-flex>
			<v-flex xs2 class="ml-10">
				<v-btn
					color="primary"
					dark
					class="mt-4"
					@click="gerarRentabilidade()"
					>Atualizar</v-btn
				>
			</v-flex>
			<v-flex xs5></v-flex>
			<v-flex class="ml-4" xs2>
				<v-spacer />
				<v-select
					v-model="selects.filiais.value"
					:items="selects.filiais.items"
					chips
					label="Selecione Filial"
					height="10"
					outlined
					item-value="id"
					item-text="descricao"
				></v-select>
			</v-flex>
			<v-flex xs1 class="ml-10">
				<v-btn
					color="primary"
					dark
					class="mt-4"
					@click="rentabilidade()"
					>Filtrar</v-btn
				>
			</v-flex>
		</v-layout>
		<v-data-table
			:headers="headersRentabilidade"
			:items="listaRentabilidade"
			:fixed-header="true"
			item-key="idfornecedor"
			:height="300"
			class="elevation-2"
			:items-per-page="-1"
		>
			<template v-slot:item="props">
				<tr
					style="height: 60px"
					:class="{
						selected_row:
							props.item.idfornecedor === edited.linhaSelecionada,
					}"
				>
					<td>{{ props.item.idfornecedor }}</td>
					<td>{{ props.item.razao_social }}</td>
					<td>
						{{
							Helpers.formatarValorMonetario(
								props.item.total_geral_venda_custo
							)
						}}
					</td>
					<td>{{ Helpers.formatarValor(props.item.markup) }} %</td>
					<td>
						{{
							Helpers.formatarValorMonetario(
								props.item.total_geral_venda
							)
						}}
					</td>
					<td>
						{{
							Helpers.formatarValorMonetario(
								props.item.total_geral_lucro
							)
						}}
					</td>
					<td>
						{{
							Helpers.formatarValorMonetario(
								props.item.valor_geral_medio
							)
						}}
					</td>
					<td>
						<v-icon
							@click="
								abrirTelaItens(props.item);
								activerow(props.item);
							"
							style="cursor: pointer"
							title="Analisar itens dessse Fornecedor"
							>mdi-eye</v-icon
						>
					</td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import DrpAPI from "./../../api/drp";
import rentabilidadeAPI from "./../../api/rentabilidade";
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			edited: {
				qtdeDias: "",
				linhaSelecionada: "",
			},

			selects: {
				grupos: {
					items: [],
					value: "",
				},
				filiais: {
					items: [],
					value: "",
				},
			},

			listaRentabilidade: [],
			headersRentabilidade: [
				{ text: "id", value: "idfornecedor" },
				{ text: "Fornecedor", value: "razao_social" },
				{
					text: "Total CMV",
					value: "total_geral_venda_custo",
				},
				{ text: "% Markup", value: "markup" },
				{ text: "Total Vendido", value: "total_geral_venda" },
				{ text: "Total Lucro Bruto", value: "total_geral_lucro" },
				{ text: "Ticket Médio", value: "valor_geral_medio" },
				{ text: "Ações", value: "icon_acoes" },
			],
		};
	},

	created() {
		this.buscarFiliais();
		this.rentabilidade();
		this.buscarAmostraAtual();
	},

	computed: {
		...mapGetters({
			grupoCompra: "usuario/getGrupoCompras",
		}),
		erroQtdeDias() {
			let erroMsg = "";
			if (parseInt(this.edited.qtdeDias) <= 0)
				erroMsg = "Qtde. de dias deve ser maior que 0 (zero)";

			return erroMsg;
		},
	},

	watch: {
		grupoCompra() {
			this.buscarFiliais();
			this.rentabilidade();
		},
	},

	methods: {
		activerow(item) {
			this.edited.linhaSelecionada = item.idfornecedor;
			this.$set(item, "selected", true);
		},

		abrirTelaItens(item) {
			item.grupo = this.grupoCompra;
			item.filial = this.selects.filiais.value;
			item.qtde_dias = this.edited.qtdeDias;
			this.$emit("telaItensFornecedor", item);
			this.$emit("atualizarDados", 1);
		},

		buscarAmostraAtual() {
			const headers = this.Helpers.iniciarRequisicao();

			this.$store.dispatch(
				"loading/addRequisicao",
				rentabilidadeAPI
					.getAmostra(headers)
					.then((response) => {
						const token = response.data.token;
						localStorage.setItem("token", token);

						this.edited.qtdeDias = response.data.amostra;
					})
					.catch(() => {
						this.Helpers.logout();
					})
			);
		},

		gerarRentabilidade() {
			if (parseInt(this.edited.qtdeDias) > 0) {
				const headers = this.Helpers.iniciarRequisicao();

				const params = { qtdeDias: this.edited.qtdeDias };

				this.$store.dispatch(
					"loading/addRequisicao",
					rentabilidadeAPI
						.gerarDadosRentabilidade(headers, params)
						.then((response) => {
							const token = response.data.token;
							localStorage.setItem("token", token);

							this.rentabilidade();
						})
						.catch(() => {
							this.Helpers.logout();
						})
				);
			}
		},

		rentabilidade() {
			const headers = this.Helpers.iniciarRequisicao();

			const params = {
				grupo: this.grupoCompra,
				filial: this.selects.filiais.value,
			};

			this.$store.dispatch(
				"loading/addRequisicao",
				rentabilidadeAPI
					.getRentabilidadeFornecedores(headers, params)
					.then((response) => {
						const token = response.data.token;
						localStorage.setItem("token", token);

						this.listaRentabilidade = response.data.rentabilidade;
					})
					.catch(() => {
						this.Helpers.logout();
					})
			);
		},

		buscarFiliais() {
			const headers = this.Helpers.iniciarRequisicao();

			const params = {
				grupo: this.grupoCompra,
			};

			this.selects.filiais.items = [];
			this.selects.filiais.value = "";

			this.$store.dispatch(
				"loading/addRequisicao",
				DrpAPI.getFiliaisDrp(headers, params)
					.then((response) => {
						const token = response.data.token;
						localStorage.setItem("token", token);

						const filiais = response.data.filiais;

						filiais.forEach((filial) => {
							if (filial.filial_cd == "N") {
								this.selects.filiais.items.push({
									id: filial.id,
									descricao: filial.descricao,
								});
							}
						});

						if (this.selects.filiais.items.length > 1) {
							this.selects.filiais.items.push({
								id: 0,
								descricao: "Todas",
							});
							this.selects.filiais.value = 0;
						} else {
							this.selects.filiais.value = this.selects.filiais.items[0].id;
						}
					})
					.catch(() => {
						this.Helpers.logout();
					})
			);
		},
	},
};
</script>

<style scoped>
.selecionada {
	background: red;
}
</style>
